/**
 * description:
 * Cycles through a fam's pictures with arrows and a position
 * counter so viewers can tell how far they are.
 */
import { useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const FamPictureCarousel = ({ images = [] }) => {
  const [index, setIndex] = useState(0);
  const count = images.length;

  const goPrev = () => setIndex((i) => (i - 1 + count) % count);
  const goNext = () => setIndex((i) => (i + 1) % count);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: { xs: "4px", md: "8px" }, width: "100%" }}>
        <IconButton
          onClick={goPrev}
          disabled={count < 2}
          aria-label="previous picture"
          disableRipple
          sx={{ p: { xs: "2px", sm: "8px" }, "&:active": { transform: "none" } }}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: { xs: "1.1rem", md: "1.3rem" } }} />
        </IconButton>

        <Box
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", sm: "440px", md: "560px", lg: "600px", xl: "620px" },
            aspectRatio: { xs: "4 / 3", sm: "16 / 9" },
            bgcolor: "background.paper",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          {count > 0 ? (
            <Box
              component="img"
              src={images[index].src}
              alt={`fam picture ${index + 1}`}
              sx={{ width: "100%", height: "100%", objectFit: images[index].fit }}
            />
          ) : (
            <Typography variant="body2" sx={{ color: "#4a4a4a" }}>
              No photos yet
            </Typography>
          )}
        </Box>

        <IconButton
          onClick={goNext}
          disabled={count < 2}
          aria-label="next picture"
          disableRipple
          sx={{ p: { xs: "2px", sm: "8px" }, "&:active": { transform: "none" } }}
        >
          <ArrowForwardIosIcon sx={{ fontSize: { xs: "1.1rem", md: "1.3rem" } }} />
        </IconButton>
      </Box>

      {count > 1 && (
        <Typography
          sx={{
            fontFamily: "Anton, sans-serif",
            letterSpacing: "1px",
            fontSize: "0.9rem",
            color: "primary.main",
          }}
        >
          {index + 1} / {count}
        </Typography>
      )}
    </Box>
  );
};

export default FamPictureCarousel;
